/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/**
 * A React component that manages the update notice functionality.
 * @returns The rendered update notice management component.
 */
// eslint-disable-next-line react-hooks/exhaustive-deps

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { components } from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import InputOption from "../../components/inputOption/inputOption";

import UpdateNoticeComponent from "./updateNoticeComponent";
import CustomeOptionLabel from "../../components/customeOptionLabel/customeOptionLabel";

import Constant from "../../util/constant";
// import "./updateNoticeManagement.scss";
import moment from "moment";
import { getNoticeTypeList } from "../../store/noticeType/actions";
import { getDepotsList } from "../../store/depots/actions";
import { editNotice } from "../../store/noticeManagement/actions";
import AWS from "aws-sdk";
import awsConfig from "../../helpers/aws-exports";

// Configure AWS SDK
/**
 * Updates the AWS configuration with the provided values.
 * @param {{region: string, accessKeyId: string, secretAccessKey: string}} config - The AWS configuration object.
 * @returns None
 */
AWS.config.update({
  region: awsConfig.aws_region,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
});

  /**
   * Uploads a file to an S3 bucket using the AWS SDK.
   * @param {{File}} file - The file to upload.
   * @param {{string}} folderPath - The path within the S3 bucket to upload the file to.
   * @returns The URL of the uploaded file.
   * @throws An error if there is an issue uploading the file.
   */
const uploadToS3 = async (file, folderPath) => {
  // Validate that file is a File object and has a name
  if (!file || !(file instanceof File) || !file.name) {
    console.warn('Skipping S3 upload: file is not a valid File object', file);
    return null;
  }

  const s3 = new AWS.S3();
  const fileName = `${folderPath}/${file.name}`;
  const params = {
    Bucket: awsConfig.aws_user_files_s3_bucket,
    Key: fileName,
    Body: file,
    ContentType: file.type,
    ACL: "public-read", // Set the ACL to make the object publicly accessible
  };

  try {
    const data = await s3.upload(params).promise();
    return data.Location; // S3 object URL
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
};

/**
 * A functional component that renders the update notice container.
 * @param {Object} props - The props passed to the component.
 * @returns The rendered update notice container.
 */
/**
 * Renders the UpdateNoticeContainer component.
 * @param {{object}} props - The props passed to the component.
 * @returns The rendered UpdateNoticeContainer component.
 */
const UpdateNoticeContainer = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let triggerRef = useRef(null);
  const { state } = useLocation();
  const selectInputRef = useRef();
  const noticeSelectInputRef = useRef();
  const updatenoticeData = state?.state?.item;
  const depotList = useSelector((state) => state?.Depots?.depotsList?.data)
  const noticeTypeList = useSelector((state) => state?.NoticeType?.noticeList?.data)
  const [placeHolder, setPlaceHolder] = useState(true);
  const [noticeForm, setNoticeForm] = useState(null);
  console.log('updatenoticeData', updatenoticeData);
  const [expirydatetime, setExpirydatetime] = useState(
    updatenoticeData?.expirydatetime
  );

  const [usersigndatetime, setUsersigndatetime] = useState(updatenoticeData?.signtill);
  const [expiryDateChange, setExpiryDateChange] = useState(false);
  const [userSignDateChange, setUserSignDateChange] = useState(false);
  console.log('usersigndatetime', usersigndatetime);
  const [headerHeight, setHeaderHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [ispriority, setIspriority] = useState(updatenoticeData?.priority);
  const [noticeTypeName, setNoticeTypeName] = useState([]);
  const [isinvalidfile, setIsinvalidfile] = useState(false);
  const [selectDepotName, setSelectDepotName] = useState([]);
  const [issignRequired, setIsignRequired] = useState(
    updatenoticeData?.signrequired === true ? "Yes" : "No"
  );
  const [isroleselect, setIsroleselect] = useState(t("UPLOAD_DOCUMENT"));
  const [isUploadingDocumentLink, setIsUploadingDocumentLink] = useState(false);
  const [isUploadingDocument, setIsUploadingDocument] = useState(false);
  const [dimenstionError, setDimenstionError] = useState(false);
  const [profileImage, setProfileImage] = useState(
    updatenoticeData?.documentthumb
  );
  const [isupdateNoticeLoaderButton, setIsupdateNoticeLoaderButton] =
    useState(false);
  const [uploadedDocumentFile, setuploadedDocumentFile] = useState(
    updatenoticeData?.documenturl
  );
  const [uploadedDocumentThumnailFile, setuploadedDocumentThumnailFile] =
    useState(updatenoticeData?.documentthumb);
  const [textTitlecount, setTextTitlecount] = useState(
    updatenoticeData?.title?.length
  );
  const [textSubTitlecount, setTextSubTitlecount] = useState(
    updatenoticeData?.subtitle?.length
  );
  const [textdescriptioncount, setTextdescriptioncount] = useState(
    updatenoticeData?.description?.length
  );

  const [depotdefaultValue, setDepotdefaultValue] = useState(
    updatenoticeData?.depotname?.map((item) => {
      return {
        label: item?.depotname,
        value: item?.depotname,
        depotId: item?.depotid,
      };
    })
  );
  const [noticedefaultValue, setNoticeTypedefaultValue] = useState(
    updatenoticeData?.noticetypename?.map((item) => {
      return {
        label: item?.noticetypename,
        value: item?.noticetypename,
      };
    })
  );

  useEffect(() => {
    setTimeout(() => {
      setPlaceHolder(false);
    }, 2000);
  });

  /**
   * Event handler for the change event of the expiry date input field.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  function onChangeExpiryDate(e) {
    if (!e.target.validity.valid) return;
    const dt = e.target.value;
    console.log('dt', dt)
    setExpiryDateChange(true)
    const formattedDate = formatDate(dt);
    setExpirydatetime(dt);
  }

  /**
   * useEffect hook that runs when the component mounts.
   * If the updatenoticeData is not undefined, it sets the placeholder state to false.
   * @returns None
   */
  useEffect(() => {
    if (updatenoticeData !== undefined) {
      setPlaceHolder(false);
    }
  }, []);

  useEffect(() => {
    getList();
  }, []);

  /**
   * Retrieves a list of depots and notice types from the server and dispatches the
   * corresponding actions to update the state.
   * @returns None
   */
  const getList = () => {
    let queryParams = {};
    queryParams.status = Constant.GENERALKEYS.ACTIVE;
    dispatch(
      getDepotsList(
        queryParams,
        (res) => { },
        (err) => console.log(err)
      )
    );

    dispatch(
      getNoticeTypeList(
        queryParams,
        (res) => { },
        (err) => console.log(err)
      )
    );
  };

  /**
   * useEffect hook that runs once when the component mounts. It retrieves the initial
   * expiry date from the updatenoticeData object, formats it using the formatDate function,
   * and sets the formatted date as the value of the expirydatetime state variable.
   * @returns None
   */

  useEffect(() => {
    const initialDate = updatenoticeData.expirydatetime;
    // const initialFormattedDate =
    //   initialDate === null ? null : formatDate(initialDate);
    const initialFormattedDate = moment(initialDate).utc().format('DD MMM YYYY, h:mm A');
    setExpirydatetime(initialFormattedDate);
  }, [updatenoticeData?.expirydatetime]);

  /**
   * useEffect hook that runs once when the component mounts. It sets the initial value of
   * the usersigndatetime state variable by formatting the initialDate obtained from the
   * updatenoticeData object using the formatDate function.
   * @param None
   * @returns None
   */
  useEffect(() => {
    const initialDate = updatenoticeData?.signtill;
    const initialFormattedDate = moment(initialDate).utc().format('DD MMM YYYY, h:mm A');;
    setUsersigndatetime(initialFormattedDate);
  }, [updatenoticeData?.signtill]);

  /**
   * Handles the change event for the user sign input field.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  function handleChangeUsersign(e) {
    if (!e.target.validity.valid) return;
    const dt = e.target.value;
    const formattedDate = formatDate(dt);
    setUserSignDateChange(true);
    setUsersigndatetime(formattedDate);
  }

  /**
   * Formats a given date into a specific format: "day month year, hours:minutes AM/PM".
   * @param {{Date}} inputDate - The date to be formatted.
   * @returns The formatted date string.
   */
  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dateObject = new Date(inputDate);
    const day = dateObject.getDate();
    const month = months[dateObject.getMonth()];
    const year = dateObject.getFullYear();
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedDate = `${day} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
    return formattedDate;
  }

  /**
   * UseEffect hook that sets the height of the header and breadcrumb elements.
   * @returns None
   */
  useEffect(() => {
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0].offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
  }, []);

  /**
   * A dictionary that maps valid file types to their corresponding file extensions for document uploads.
   * @type {{string: string}}
   */
  const uploadDocumentValid = {
    "application/msword": [],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      [],
    "application/pdf": [],
    "image/png": [],
    "application/x-scorm": [],
    "application/zip": []
  };

  /**
   * A dictionary object that maps valid thumbnail file types to their corresponding file extensions.
   * @type {{string: string}}
   */
  const uploadThumNailValid = {
    "image/png": [],
  };

  /**
   * Navigates to the "/noticemanagement" page.
   * @returns None
   */
  const backPageFunction = () => {
    navigate("/noticemanagement");
  };

  /**
   * Updates the notice form state with the provided form object.
   * @param {{object}} form - The new form object to update the notice form state.
   * @returns None
   */
  const updateNoticeForm = (form) => {
    setNoticeForm(form);
  };

  /**
   * Event handler for the change event of a radio input in the Roleradio component.
   * Updates the value of the isroleselect state variable based on the selected radio input value.
   * Clears the uploaded user file, resets the isUploadingDocument state variable to false,
   * sets the uploadedDocumentFile state variable to null.
   * Resets the value of the "documentfile" field in the noticeForm to an empty string without validation.
   * Resets the value of the "addink" field in the noticeForm with validation.
   * @param {{Event}} e - The event object representing the change event.
   * @returns None
   */
  const roleradioChangeHandler = (e) => {
    setIsroleselect(e.target.value);
    handleClearUploadedUserFile();
    setIsUploadingDocument(false);
    setuploadedDocumentFile(null);
    noticeForm.setValue("documentfile", "", {
      shouldValidate: true,
    });
    noticeForm.setValue("addink", "", {
      shouldValidate: true,
    });
    noticeForm.setValue("navlink", "", {
      shouldValidate: true,
    });
  };

  /**
   * Event handler for the sign required change event.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const signRequiredChangeHandler = (e) => {
    setIsignRequired(e.target.value);
    if (issignRequired === 'No') {
      noticeForm.setValue("usersign", null, {
        shouldValidate: true,
      });
      setUsersigndatetime("")
    } else {
      noticeForm.setValue("usersign", null, {
        shouldValidate: true,
      });
    }
  };

  /**
   * Event handler for changing the priority value.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const priorityChangeHandler = (e) => {
    setIspriority(e.target.value);
  };

  /**
   * Handles the change event for the text title input field.
   * Updates the character count of the input value.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const handleTextTitleChange = (e) => {
    const value = e.target.value;
    setTextTitlecount(value.length);
  };

  /**
   * Handles the change event for the subtitle input field.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const handleSubtitleChange = (e) => {
    const value = e.target.value;
    setTextSubTitlecount(value.length);
  };

  /**
   * Handles the change event of a text description input field.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const handleTextdescriptionChange = (e) => {
    const value = e.target.value;
    setTextdescriptioncount(value.length);
  };

  /**
   * Generates a memoized object that represents the form fields and their validation rules
   * for adding a notice.
   * @param {{string}} issignRequired - Indicates whether a signature is required for the notice.
   * @returns An object representing the form fields and their validation rules.
   */
  const addNoticeForm = {
    documentfile: {
      name: "documentfile",
      validate: {
        required: {
          value: isroleselect === "Add Link" ? false : true,
        },
      },
    },
    thumbnailfile: {
      name: "thumbnailfile",
      validate: {
        required: {
          value: false,
        },
      },
    },
    navlink: {
      name: "navlink",
      validate: {
        required: {
          value: true,
        },
        pattern: {
          value: Constant.REGEX.NOTICE_URL,
        },
      },
    },

    noticetype: {
      name: "noticetype",
      validate: {
        required: {
          value: true,
        },
      },
    },
    title: {
      name: "title",
      validate: {
        required: {
          value: true,
        },
        maxLength: {
          value: 100,
        },
      },
    },
    subtitle: {
      name: "subtitle",
      validate: {
        required: {
          value: false,
        },
        maxLength: {
          value: 200,
        },
      },
    },

    description: {
      name: "description",
      validate: {
        required: {
          value: true,
        },
        maxLength: {
          value: 250,
        },
      },
    },

    depot: {
      name: "depot",
      validate: {
        required: {
          value: true,
        },
      },
    },
    expirydate: {
      name: "expirydate",
      validate: {
        required: {
          value: false,
        },
      },
    },
    usersign: {
      name: "usersign",
      validate: {
        required: {
          value: issignRequired === "No" ? false : true,
        },
      },
    },
    fullname: {
      name: "fullname",
      validate: {
        required: {
          value: issignRequired === "No" ? false : true,
        },
      },
    },
    priority: {
      name: "priority",
      validate: {
        required: {
          value: false,
        },
      },
    },
    signrequired: {
      name: "signrequired",
      validate: {
        required: {
          value: false,
        },
      },
    },
  };



  /**
   * A custom input option component for a select dropdown.
   * @param {{getStyles}} getStyles - Function to get the styles for the component.
   * @param {{Icon}} Icon - The icon component to display.
   * @param {{boolean}} isDisabled - Whether the option is disabled.
   * @param {{boolean}} isSelected - Whether the option is selected.
   * @param {{ReactNode}} children - The content to display within the option.
   * @param {{object}} innerProps - Additional props to pass to the inner component.
   * @param {...rest} rest - Additional props to pass to the component.
   * @returns The rendered input option component.
   */

  /**
   * Clears the uploaded user file and resets the form field value.
   * @returns None
   */
  const handleClearUploadedUserFile = () => {
    setuploadedDocumentFile(null);
    noticeForm.setValue("documentfile", null, {
      shouldValidate: true,
    });
  };

  /**
   * Clears the uploaded thumbnail file by setting it to null.
   * @returns None
   */
  const handleClearUploadedThumnailFile = () => {
    setuploadedDocumentThumnailFile(null);
    setProfileImage(null);
    noticeForm.setValue("thumbnailfile", null, {
      shouldValidate: false,
    });
  };

  /**
   * Handles the upload of a document file.
   * @param {{FileList}} files - The list of files to be uploaded.
   * @returns None
   */
  const handleUploadDocumentFile = (files) => {
    setuploadedDocumentFile(files[0]);

  };

  /**
   * Handles the upload of a thumbnail file.
   * @param {{File}} files - The file(s) to be uploaded.
   * @returns None
   */
  const handleUploadThumnailFile = (files) => {
    setuploadedDocumentThumnailFile(files[0]);

  };

  /**
   * Handles the upload of a document by calling the provided upload function after a delay.
   * @param {{FileList}} files - The list of files to upload.
   * @param {{function}} loaderState - The function to update the loader state.
   * @param {{function}} uploadFunction - The function to handle the upload of the files.
   * @returns None
   */
  const handleUploadDocument = (files, loaderState, uploadFunction) => {
    loaderState(true);
    setTimeout(() => {
      uploadFunction(files);
      loaderState(false);
    }, 1000);
  };

  /**
   * Handles the upload of a thumbnail image file.
   * @param {{FileList}} files - The list of files to upload.
   * @param {{function}} loaderState - The function to update the loader state.
   * @param {{function}} uploadFunction - The function to handle the upload of the files.
   * @returns None
   */
  // const handleUploadThumnail = (files, loaderState, uploadFunction) => {
  //   loaderState(true);
  //   const reader = new FileReader();
  //   reader.addEventListener("load", (event) => {
  //     setProfileImage(event.target.result);
  //   });
  //   reader.readAsDataURL(files[0]);
  //   setTimeout(() => {
  //     uploadFunction(files);
  //     loaderState(false);
  //   }, 1000);
  // };
  const handleUploadThumnail = (files, loaderState, uploadFunction) => {
    if (files && files.length > 0) {
      loaderState(true);
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        setProfileImage(event.target.result);
      });
      reader.readAsDataURL(files[0]);
      setTimeout(() => {
        uploadFunction(files);
        loaderState(false);
      }, 1000);
    } else {
      // Handle the case where no file is selected (e.g., show an error message).
      console.error("No file selected.");
    }
  };




  /**
   * useEffect hook that updates the value of isRoleSelect based on the value of noticeForm.
   * If noticeForm is not null, it sets isRoleSelect to either "ADD_LINK" or "UPLOAD_DOCUMENT"
   * based on the value of updatenoticeData.noticelink.
   * @param {{function}} callback - The callback function to be executed when the dependency array changes.
   * @param {{Array}} dependencies - An array of dependencies that trigger the callback when changed.
   * @returns None
   */
  useEffect(() => {
    if (noticeForm !== null) {
      setIsroleselect(
        updatenoticeData?.noticelink ? t("ADD_LINK") : t("UPLOAD_DOCUMENT")
      );
    }
  }, [noticeForm, t, updatenoticeData?.noticelink]);

  /**
   * Uploads the given document and thumbnail files to an S3 bucket based on the provided conditions.
   * @param {{any}} document - The document file to upload.
   * @param {{any}} thumbnail - The thumbnail file to upload.
   * @param {{boolean}} navlink - A flag indicating whether a navlink is present.
   * @returns None
   */
  const getDocAndThum = async (document, thumbnail, navlink) => {
    console.log('document--', document);
    console.log('thumbnail--', thumbnail);
    console.log('navlink--', navlink);
    
    // Only upload if uploadedDocumentFile is a File object (not a string URL)
    const isNewDocumentFile = uploadedDocumentFile instanceof File;
    const isNewThumbnailFile = uploadedDocumentThumnailFile instanceof File;
    
    if (isNewDocumentFile && !isNewThumbnailFile) {
      await uploadToS3(uploadedDocumentFile, 'document');
    } else if (isNewDocumentFile && isNewThumbnailFile) {
      await uploadToS3(uploadedDocumentFile, 'document');
      await uploadToS3(uploadedDocumentThumnailFile, 'thumbnail');
    } else if (!isNewDocumentFile && isNewThumbnailFile) {
      await uploadToS3(uploadedDocumentThumnailFile, 'thumbnail');
    } else {
    }
  }

  /**
   * Handles the form submission by updating the notice and displaying a success toast message.
   * @param {{object}} data - The form data submitted.
   * @returns None
   */
  const handleFormSubmit = async (data) => {
    console.log('usersign', data?.usersign);
    setIsupdateNoticeLoaderButton(true);
    await getDocAndThum(data?.documentfile, data?.thumbnailfile, data?.navlink)

    const depotId = depotdefaultValue?.map((item) => item?.depotId)
    const defaultNoticeTypeID = updatenoticeData?.noticetypename[0]?.noticetypeid
    const noticeTypeId = data?.noticetype?.noticeTypeId

    const params = {
      noticetypeid:
        noticeTypeId === undefined ? defaultNoticeTypeID : noticeTypeId,
      title: data?.title,
      description: data?.description,
      depotid: depotId,
      priority: data?.priority,
      signrequired: data?.signrequired === 'Yes' ? true : false,
    }
    if (data?.expirydate === "Invalid date" || data?.expirydate === "") {
      console.log("true");
    } else {
      params["expirydatetime"] = moment.utc(expirydatetime).format('YYYY-MM-DD');
    }
    if (data?.usersign === "Invalid date" || data?.usersign === "" || !data?.usersign || data?.signrequired === 'No') {
      console.log("true");
    } else {
      params["signtill"] = moment.utc(usersigndatetime).format('YYYY-MM-DD');;
    }
    if (data?.subtitle) {
      params['subtitle'] = data?.subtitle
    }
    // Handle documenturl: use new file name if uploaded, otherwise preserve existing
    if (uploadedDocumentFile instanceof File) {
      // New file uploaded - use the file name
      params['documenturl'] = uploadedDocumentFile.name;
    } else if (typeof uploadedDocumentFile === 'string' && uploadedDocumentFile) {
      // No new file, but preserve existing document URL
      // Extract filename from URL if it's a full URL, otherwise use as-is
      const lastSlashIndex = uploadedDocumentFile.lastIndexOf("/");
      const filename = lastSlashIndex !== -1 
        ? uploadedDocumentFile.substring(lastSlashIndex + 1)
        : uploadedDocumentFile;
      params['documenturl'] = filename;
    }
    // Handle documentthumb: use new file name if uploaded, otherwise preserve existing
    if (uploadedDocumentThumnailFile instanceof File) {
      // New thumbnail uploaded - use the file name
      params['documentthumb'] = uploadedDocumentThumnailFile.name;
    } else if (typeof uploadedDocumentThumnailFile === 'string' && uploadedDocumentThumnailFile) {
      // No new thumbnail, but preserve existing thumbnail URL
      // Extract filename from URL if it's a full URL, otherwise use as-is
      const lastSlashIndex = uploadedDocumentThumnailFile.lastIndexOf("/");
      const filename = lastSlashIndex !== -1 
        ? uploadedDocumentThumnailFile.substring(lastSlashIndex + 1)
        : uploadedDocumentThumnailFile;
      params['documentthumb'] = filename;
    }
    if (data?.navlink) {
      params['noticelink'] = data?.navlink
    }


    dispatch(
      editNotice(
        updatenoticeData?.noticeid,
        params,
        (res) => {
          setIsupdateNoticeLoaderButton(false);
          navigate("/noticemanagement");
          noticeForm.reset(
            {
              documentfile: [],
              navlink: "",
              addink: "",
              title: "",
              noticetype: "",
              subtitle: "",
              description: "",
              depot: "",
              usersign: "",
              expirydate: "",
            },
            noticeSelectInputRef.current.clearValue(),
            selectInputRef.current.clearValue(),
            handleClearUploadedUserFile(),
            handleClearUploadedThumnailFile(),
            setTextTitlecount(0),
            setTextSubTitlecount(0),
            setTextdescriptioncount(0),
            setExpirydatetime(""),
            setUsersigndatetime("")
          );
        },
        (err) => {
          setIsupdateNoticeLoaderButton(false);
          console.log(err);
        }
      )
    );
  };

  /**
   * Extracts the filename from the given uploaded document file path.
   * @param {{string}} uploadedDocumentFile - The path of the uploaded document file.
   * @returns The extracted filename from the file path.
   */
  const uploadedDocumentFilename = uploadedDocumentFile;
  let fileName = "";
  if (typeof uploadedDocumentFilename === "string") {
    const lastSlashIndex = uploadedDocumentFilename?.lastIndexOf("/");
    if (lastSlashIndex !== -1) {
      fileName = uploadedDocumentFilename?.substring(lastSlashIndex + 1);
    }
  }

  /**
   * Formats the input date string into the desired format using Moment.js library.
   * @param {{string}} inputDateString - The input date string to be formatted.
   * @param {{string}} desiredFormat - The desired format for the output date string.
   * @returns The formatted date string in the desired format.
   */
  const inputDateString = expirydatetime;
  const desiredFormat = "YYYY-MM-DD HH:mm";
  const formattedDate = moment.utc(inputDateString).local().format('YYYY-MM-DD HH:mm');
  // const formattedDate = moment(inputDateString).format(desiredFormat);

  /**
   * Get the current date and format it according to the specified format.
   * @returns {string} The formatted current date.
   */
  const currentDate = new Date();
  const currentFormat = "YYYY-MM-DD HH:mm";
  const currentformattedDate = moment(currentDate).format(currentFormat);

  const expireDate = expirydatetime;
  const expireFormat = "YYYY-MM-DD HH:mm";
  const expireformattedDate = moment(expireDate).format(expireFormat);
  /**
   * Formats a given date string using the specified format.
   * @param {{string}} date - The date string to format.
   * @param {{string}} format - The format to apply to the date string.
   * @returns The formatted date string.
   */
  const UserString = usersigndatetime;
  const UserStringFormat = "YYYY-MM-DD HH:mm";
  const UserStringformattedDate = moment.utc(UserString).local().format('YYYY-MM-DD HH:mm');
  // const UserStringformattedDate = moment(UserString).format(UserStringFormat);

  /**
   * Renders a component that displays an update notice form with various input fields and options.
   * @param {{string}} innerPagetitle - The title of the inner page.
   * @param {{function}} backPageFunction - The function to navigate back to the previous page.
   * @param {{object}} addNoticeForm - The form object for adding a notice.
   * @param {{boolean}} isroleselect - Indicates whether role selection is enabled.
   * @param {{function}} roleradioChangeHandler - The function to handle changes in the role radio buttons.
   * @param {{object}} selectInputRef - The reference to the select input element.
   * @param {{object}} noticeSelectInputRef - The reference to the notice select input
   */
  const depotOptions = depotList?.map((item) => ({
    label: item?.name,
    value: item?.name,
    depotId: item?.depotid,
  })) || [];

  return (
    <>
      <UpdateNoticeComponent
        innerPagetitle={t("UPDATE_NOTICE")}
        backPageFunction={backPageFunction}
        addNoticeForm={addNoticeForm}
        isroleselect={isroleselect}
        roleradioChangeHandler={(e) => {
          roleradioChangeHandler(e);
        }}
        selectInputRef={selectInputRef}
        noticeSelectInputRef={noticeSelectInputRef}
        formatOptionLabel={<CustomeOptionLabel />}
        components={{ Option: InputOption }}
        textTitlecount={textTitlecount}
        handleTextTitleChange={handleTextTitleChange}
        textSubTitlecount={textSubTitlecount}
        handleSubtitleChange={handleSubtitleChange}
        handleTextdescriptionChange={handleTextdescriptionChange}
        textdescriptioncount={textdescriptioncount}
        optionNoticeName={noticeTypeList?.map((item) => {
          return {
            label: item?.name,
            value: item?.name,
            noticeTypeId: item?.noticetypeid,
          };
        })}
        onChangeNoticeType={(options) => {
          setNoticeTypedefaultValue(options);
          if (Array.isArray(options)) {
            setNoticeTypeName(options.map((opt) => opt.value));
          }
        }}
        optionDepotName={[
          { label: t("SELECT_ALL"), value: "select-all" },
          ...depotOptions
        ]}
        onChangeDepotName={(selectedOptions) => {
          const hasSelectAll = selectedOptions?.some((opt) => opt.value === "select-all");
          let resolved;

          if (hasSelectAll) {
            const realSelected = selectedOptions.filter((opt) => opt.value !== "select-all");
            resolved = realSelected.length >= depotOptions.length ? [] : depotOptions;
          } else {
            resolved = selectedOptions || [];
          }

          setDepotdefaultValue(resolved);
          setSelectDepotName(resolved.map((opt) => opt.value));
          return resolved;
        }}
        issignRequired={issignRequired}
        signRequiredChangeHandler={(e) => {
          signRequiredChangeHandler(e);
        }}
        ispriority={ispriority}
        priorityChangeHandler={priorityChangeHandler}
        handleUploadDocumentFile={handleUploadDocumentFile}
        handleClearUploadedUserFile={handleClearUploadedUserFile}
        uploadedDocumentFile={uploadedDocumentFile}
        uploadDocumentValid={uploadDocumentValid}
        uploadThumNailValid={uploadThumNailValid}
        handleUploadDocument={handleUploadDocument}
        handleUploadThumnail={handleUploadThumnail}
        handleUploadThumnailFile={handleUploadThumnailFile}
        uploadedDocumentThumnailFile={uploadedDocumentThumnailFile}
        noticeTypeName={noticeTypeName}
        selectDepotName={selectDepotName}
        updateNoticeFunction={updateNoticeForm}
        handleFormSubmit={handleFormSubmit}
        isUploadingDocument={isUploadingDocument}
        isUploadingDocumentLink={isUploadingDocumentLink}
        profileImage={profileImage}
        isinvalidfile={isinvalidfile}
        setIsUploadingDocument={setIsUploadingDocument}
        setIsUploadingDocumentLink={setIsUploadingDocumentLink}
        setIsinvalidfile={setIsinvalidfile}
        updateNoticeLoaderButton={isupdateNoticeLoaderButton}
        handleClearUploadedThumnailFile={handleClearUploadedThumnailFile}
        triggerRef={triggerRef}
        expirydatetime={expirydatetime}
        onChangeExpiryDate={onChangeExpiryDate}
        headerHeight={headerHeight}
        breadcrumbHeight={breadcrumbHeight}
        noticedefaultValue={noticedefaultValue}
        depotdefaultValue={depotdefaultValue}
        dimenstionError={dimenstionError}
        setDimenstionError={setDimenstionError}
        updatenoticeData={updatenoticeData}
        usersigndatetime={usersigndatetime}
        handleChangeUsersign={(ev) => {
          handleChangeUsersign(ev);
        }}
        fileName={fileName}
        currentformattedDate={currentformattedDate}
        formattedDate={formattedDate}
        UserStringformattedDate={UserStringformattedDate}
        placeHolderShimer={placeHolder}
        expireformattedDate={expireformattedDate}
        expiryDateChange={expiryDateChange}
        userSignDateChange={userSignDateChange}
      />
    </>
  );
};

export default UpdateNoticeContainer;
